export const packagePageRoutes = [
  '/packages/cremation-essentials',
  '/packages/heartfelt-memorial',
  '/packages/complete-funeral'
];

// purchase flow screen name routes
// keys are based on possible user.preneed.lastScreeen.screen
export const screenNameRoutes = {
  packageComparison: '/get-my-price/', // apps only screen
  extraAccountDetails: '/get-my-price/keys/', // not part of navigator
  getEstimates: '/get-my-price/',
  selectPackage: '/get-my-price/select-package/',
  chooseProvider: '/get-my-price/select-provider/',
  getUserPhone: '/get-my-price/create-account/',
  completeDetails: '/your-price/',
  submitOrder: '/order/summary/',
  orderCompletionSummary: '/thank-you/'
};
